import useModals from "../../../hooks/useModals";
import AddGuide from "../modals/AddGuide";
import upload from "../../../assets/icons/darkIcons/download.svg";
import { guidesSocial } from "../../../data/social";
import { getGuideSocial } from "../../../api/social";
import { showToastError } from "../../../services/toast";

const GuideSocial = () => {
  const { modals, openModals, openModal, closeModal } = useModals();

  const handleGetGuide = (id: number, title: string) => {
    console.log("id", id, "title", title);

    getGuideSocial(
      title.toLowerCase() === "guide social français" ? "FR" : "EN",
    )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          title.toLowerCase() === "guide social français"
            ? "guide_social_fr.pdf"
            : "guide_social_en.pdf",
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {
        showToastError(err.response.data.message);
      });
  };

  return (
    <div className="flex flex-col gap-5">
      {Object.keys(modals).map((modalId) =>
        openModals[modalId] ? <div key={modalId}>{modals[modalId]}</div> : null,
      )}

      {/* En-tête */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-sm">
        <div className="min-w-0">
          <p className="text-[11px] font-bold tracking-wider text-slate-400 uppercase">
            Guide social
          </p>
          <h2 className="mt-1 text-xl font-bold tracking-tight text-slate-900">
            Guides social en anglais et français
          </h2>
          <p className="mt-1 font-Nunito text-sm text-slate-500">
            Gérez vos guides social et mettez-les à jour en quelques clics.
          </p>
        </div>
      </div>

      {/* Liste */}
      <div className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
        <div className="max-h-[60vh] overflow-y-auto divide-y divide-slate-100">
          {guidesSocial.map((guide) => (
            <div
              key={guide.id}
              className="flex flex-wrap items-center justify-between gap-4 px-5 py-4 transition-colors hover:bg-slate-50"
            >
              <div className="min-w-0">
                <p className="font-Nunito text-sm font-semibold text-slate-900">
                  {guide.title}
                </p>
                <p className="mt-0.5 text-xs text-slate-400">
                  Modèle n°{guide.id}
                </p>
              </div>
              <div className="flex flex-wrap items-center gap-2">
                <button
                  type="button"
                  className="inline-flex size-9 cursor-pointer items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-500 transition-colors hover:border-slate-300 hover:bg-slate-50 hover:text-slate-700 focus-visible:ring-2 focus-visible:ring-slate-300 focus-visible:outline-none"
                  onClick={() => handleGetGuide(guide.id, guide.title)}
                  aria-label={`Télécharger ${guide.title}`}
                  title="Télécharger"
                >
                  <img src={upload} alt="" className="size-4 opacity-70" />
                </button>
                <button
                  type="button"
                  className="inline-flex cursor-pointer items-center justify-center gap-1.5 rounded-xl border border-slate-200 bg-white px-3.5 py-2 font-Nunito text-sm font-semibold text-slate-700 shadow-sm transition-colors hover:border-slate-300 hover:bg-slate-50 focus-visible:ring-2 focus-visible:ring-slate-300 focus-visible:outline-none"
                  onClick={() =>
                    openModal(
                      "addGuide",
                      <AddGuide
                        closeModal={() => closeModal("addGuide")}
                        id={guide.id}
                        update={true}
                      />,
                    )
                  }
                >
                  Remplacer
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GuideSocial;
